import { PlayCircle, Video } from "lucide-react";

const VIDEO_SLOTS = [
  { label: "Discourse · 01", desc: "Introduction to Vedic Astrology" },
  { label: "Discourse · 02", desc: "Understanding Your Birth Chart" },
  { label: "Discourse · 03", desc: "Vastu for Modern Homes" },
];

export default function VideoGallery() {
  return (
    <section
      id="video-gallery"
      data-testid="video-gallery-section"
      className="section relative"
    >
      <div className="container-luxe">
        <div className="reveal max-w-2xl">
          <div className="text-[11px] tracking-[0.4em] uppercase text-gold-light">
            Video Gallery · वीडियो
          </div>
          <h2
            data-testid="video-gallery-title"
            className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1.05] text-cream"
          >
            Discourses &{" "}
            <span className="italic font-editorial gold-text">satsangs</span>.
          </h2>
          <p className="mt-5 text-cream-muted">
            Recorded discourses, ceremony highlights and short teachings. Upload
            your own videos or embed YouTube links later.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {VIDEO_SLOTS.map((v, i) => (
            <div
              key={i}
              data-testid={`video-slot-${i}`}
              className="reveal glass rounded-2xl overflow-hidden group cursor-pointer hover:border-[#D4AF37]/40 transition-colors duration-500"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div className="relative aspect-video bg-[radial-gradient(circle_at_center,rgba(212,175,55,0.14),transparent_60%)] grid place-items-center">
                <div className="absolute inset-3 border border-dashed border-[#D4AF37]/25 rounded-xl" />
                <div className="relative w-16 h-16 rounded-full gold-border grid place-items-center bg-[#050B14]/60 group-hover:bg-[#D4AF37]/20 transition-colors duration-500">
                  <PlayCircle
                    className="w-8 h-8 text-gold"
                    strokeWidth={1.2}
                  />
                </div>
              </div>
              <div className="p-5 border-t border-white/5">
                <div className="flex items-center gap-2 text-gold">
                  <Video className="w-4 h-4" strokeWidth={1.4} />
                  <span className="font-display text-[11px] tracking-[0.3em]">
                    {v.label}
                  </span>
                </div>
                <div className="mt-2 font-editorial text-lg text-cream">
                  {v.desc}
                </div>
                <div className="mt-3 text-[11px] tracking-[0.22em] uppercase text-cream-muted">
                  Video Placeholder
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
